import {create} from "zustand";
import { subscribeWithSelector, persist } from 'zustand/middleware'
import {getCurrentUser, loginUser, logoutServer} from "../api/users";
import {difference, intersection} from "lodash";

const emptyUser = {
    status: null,
    email: '',
    username: '',
    permissions: [],
    roles: [],
    partners: [],
};

const useUserStore = create(
    persist(
        subscribeWithSelector((set) => ({
            user: {
                status: null,
                email: '',
                username: '',
                permissions: [],
                roles: [],
                partners: [],
            },
            accessToken: '',
            login: async (email, password) => {
                const response = await loginUser(email, password);
                const responseUser = response.data;

                if (responseUser.success === true) {

                    const user = responseUser.data;

                    set((state) => ({
                        user: {
                            ...state.user,
                            email: user.email,
                            status: 'login'
                        },
                        accessToken: user.token
                    }))

                    await useUserStore.getState().loadUserInfo()
                    return true
                }
            },
            loadUserInfo: async () => {
                const response = await getCurrentUser();
                const responseUserInfo = response.data;
                if (responseUserInfo.success === true) {
                    const userInfo = response.data.data;

                    set((state) => ({
                        user: {...state.user,
                            id: userInfo.id,
                            email:userInfo.email,
                            roles: userInfo.roles ?? [],
                            permissions: userInfo.permissions ?? [],
                            partners: userInfo.partners ?? [],
                            metadata: userInfo.metadata,
                        }
                    }))
                }
            },
            // Vide la session locale (token + user). Utilisé au logout et à l'éviction (401).
            removeCredentials: () => {
                set({ accessToken: null, user: { ...emptyUser } });
            },
            logoutUser: async () => {
                try {
                    await logoutServer();
                } catch (e) {
                    // best-effort : on vide la session locale même si l'appel serveur échoue
                }
                useUserStore.getState().removeCredentials();
            },
            can: (requiredPermissions,inclusivePermission = false) => {
                return inclusivePermission
                    ? intersection(useUserStore.getState().user?.permissions, requiredPermissions).length
                    : difference(requiredPermissions, useUserStore.getState().user?.permissions).length === 0;
            }

        })),
        {
            name: 'user',
            merge: (persistedState, currentState) => ({
                ...currentState, ...(persistedState)
            })
        }
    )
) ;

// Sync multi-onglets : si un autre onglet vide la session (logout/éviction),
// on propage la déconnexion à cet onglet.
if (typeof window !== "undefined") {
    window.addEventListener("storage", (event) => {
        if (event.key !== "user") return;
        const token = useUserStore.getState().accessToken;
        if (!token) return;
        const persisted = event.newValue ? JSON.parse(event.newValue) : null;
        if (!persisted?.state?.accessToken) {
            useUserStore.getState().removeCredentials();
        }
    });
}

export default useUserStore;